module.exports = __webpack_public_path__ + "media/images/application/template/icon--link-external-5b65d53b6b02355a719c54012bea1814.svg";